'use client';

import { BaseTranslations } from '../../../../baseTranslations';
import { CmsProduct } from '../../../../types/cmsProduct';
import { PushDataLayerFn } from '../../../../types/pushDataLayer';
import {
  ComponentTypeEnum,
  sendProductAnalytics,
  UserActionEnum,
} from '../../../../utils/analytics';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { sessionAttributionTracker } from '../../../../utils/sessionAttributionTracking/sessionAttributionTracker';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { ApplyCtaLink } from '../../../ApplyCta';
import Button from '../../../Button';

type StickyNavigationBarApplyButtonProps = {
  product?: CmsProduct;
  pushDataLayer?: PushDataLayerFn;
  // Standardised TI label (resolveTiCtaLabel). Falls back to the default when absent.
  label?: string;
  itemListName?: string;
};

export const StickyNavigationBarApplyButton: React.FC<
  StickyNavigationBarApplyButtonProps
> = ({ product, pushDataLayer, label, itemListName }) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  if (!product) return null;

  const sendAnalyticsForButtonApply = () => {
    sessionAttributionTracker.recordApplyClick();

    if (pushDataLayer) {
      sendProductAnalytics({
        action: UserActionEnum.CLICK,
        componentTitle: 'Sticky Navigation Bar/CTA_Apply Now',
        componentType: ComponentTypeEnum.TOP_STICKY,
        event: 'product_click_apply',
        index: '0',
        itemListName,
        product,
        pushDataLayer,
      });
    }
  };

  return (
    <ApplyCtaLink
      product={product}
      target="_blank"
      rel="noreferrer noopener"
      className="inline-block"
    >
      <Button
        className="mhg-alpha-btn-small"
        styleType="cta"
        onClick={sendAnalyticsForButtonApply}
      >
        {label ?? staticText.apply_now}
      </Button>
    </ApplyCtaLink>
  );
};
